import { BreadcrumbProps } from "./types";
import { useBreadcrumb } from "./useBreadcrumb";
import BreadcrumbContent from "./BreadcrumbContent";

const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const { breadcrumbs, translate } = useBreadcrumb(props);

  return (
    <BreadcrumbContent
      breadcrumbs={breadcrumbs}
      translate={translate}
      withoutLink={props.withoutLink}
      suffix={props.suffix}
      customLabel={props.customLabel}
      containerClassName={props.containerClassName}
      itemClassName={props.itemsClassName}
      isFullWidtContainer={props.isFullWidthContainer}
    />
  );
};

export default Breadcrumb;
